import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { Title } from "@angular/platform-browser";
import { QlikService } from "../../felles/services/qlik.service";
import { IconComponent } from "@husbanken/designsystem-angular-core";

@Component({
  selector: "stat-om",
  templateUrl: "./om.component.html",
  imports: [IconComponent],
})
export class OmComponent implements OnInit, OnDestroy {
  qlikService = inject(QlikService);
  titleService = inject(Title);

  kpi = null;
  collector: Subscription = new Subscription();

  ngOnInit() {
    this.titleService.setTitle("Om statistikkbanken - Husbanken");
    this.qlikService
      .getKpi("DatalastTidspunkt")
      .subscribe(result => {
        this.kpi = result;
      })
      .add(this.collector);
  }

  ngOnDestroy() {
    this.collector.unsubscribe();
  }
}
